'use client';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

const QUERY_KEY = 'focusElement';
export const buildElementFocusSearch = (elementKey: string) => {
  const params = new URLSearchParams();
  params.set(QUERY_KEY, elementKey);
  return params.toString();
};
export const useElementFocus = ({
  ref,
  elementKey,
  enabled,
}: {
  ref: React.RefObject<HTMLElement>;
  elementKey: string;
  enabled: boolean;
}) => {
  const history = useRouter();
  const search = useSearchParams();

  useEffect(() => {
    const params = new URLSearchParams(search);
    if (!params.has(QUERY_KEY) || !enabled || ref.current == null) {
      return;
    }
    if (elementKey !== params.get(QUERY_KEY)) return;
    const timer = setTimeout(() => {
      if (!ref.current) return;
      window?.scrollTo?.({ top: ref.current.offsetTop, behavior: 'smooth' });
      params.delete(QUERY_KEY);
      // history.push({ search: params.toString() });
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [search, enabled, ref, elementKey, history]);
};

export const useElementFocusBySelector = ({
  selector,
  enabled,
  onScrolled,
}: {
  selector: string | undefined | null;
  enabled: boolean;
  onScrolled?: () => void;
}) => {
  useEffect(() => {
    if (enabled && selector) {
      try {
        const faqElement = document.querySelector(selector);
        if (faqElement) {
          setTimeout(() => {
            faqElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
            onScrolled?.();
          }, 0);
        }
      } catch {
        //
      }
    }
  }, [enabled, selector]);
};
